import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {LoginService}
 */
export default class LoginService {

  constructor(){    
    this.resource = "/auth"
    this.http = Rest.build(store.getters.token, this.resource);
  }

  static build(){    
    return new this();
  }

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  login (record) {    
    return this.http.post('/login', record)
  }

  request_new_password(email){
    return this.http.post(`/request_password_reset/`, {email:email});
  }

  verify_requested_password(hash){
    return this.http.post(`/request_password_reset/verifyhash`, {hash:hash});
  }

  password_reset(data){
    return this.http.post(`/password_reset/`, data);
  }

  refresh_token(){
    return this.http.get(`/refreshtoken`);
  }

  verify_email(hash){
    return this.http.get(`/emailverify/${hash}`);
  }

  logout () {    
    return this.http.post('/logout')
  }

}